import type { SVGProps, FC } from "react";

interface Props extends SVGProps<SVGSVGElement> { }

const CloseIcon
  : FC<Props> = (props) => {
    return (
      <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Group">
          <g id="Group_2">
            <path id="Path" d="M8 8L16 16" stroke="#999999" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path id="Path_2" d="M16 8L8 16" stroke="#999999" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </g>
        </g>
      </svg>

    );
  };

export default CloseIcon
  ;
